var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSwap = function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14 6.86.36 9.65c-.19.2-.19.51 0 .71l2.78 2.79c.31.32.85.09.85-.35V11H10c.55 0 1-.45 1-1s-.45-1-1-1H3.99V7.21c0-.45-.54-.67-.85-.35Zm14.51-3.21L14.87.86c-.31-.32-.85-.09-.85.35V3H8c-.55 0-1 .45-1 1s.45 1 1 1h6.01v1.79c0 .45.54.67.85.35l2.78-2.79c.2-.19.2-.51.01-.7Z",
    fill: "#FFF"
  })));
};
export default SvgSwap;